import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { FeedbackObject } from "@/components/types";
// Types for Slack feedback

export interface SlackFeedbackResponse {
  success: boolean;
  message: string;
}

// Slack webhook URL

// Create the API slice
export const slackApi = createApi({
  reducerPath: "slackApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "", // We'll use the full URL in the endpoints
  }),
  tagTypes: ["Feedback"],
  endpoints: (builder) => ({
    sendFeedback: builder.mutation<SlackFeedbackResponse, FeedbackObject>({
      query: (feedbackObject) => ({
        url: "/slack-webhook",
        method: "POST",
        body: feedbackObject,
        responseHandler: (response) => response.text(),
      }),
      transformResponse: (response: string) => ({
        success: response === "ok",
        message: response === "ok" ? "Feedback sent successfully" : response,
      }),
      invalidatesTags: ["Feedback"],
    }),
  }),
});

// Export hooks for usage in functional components
export const { useSendFeedbackMutation } = slackApi;
